<Div *ngIf="canAccess"></Div>
<div class="list_block" [hidden]="editMode">
  <!-- NEW GENERIC LIST COMPONENT -->
  <app-generic-list class="w-full flex-col" *ngIf="!showSpinnerItems"
                    filterKeyPrefix="items"
                    [items]="items"
                    (itemClick)="onItemClick($event)"
                    [filterFields]="filterFields"
                    [showFilters]="true"
                    [isFiltersCollapsed]="true"
                    [allowDownload]="false"
                    (filtersChanged)="onFiltersChanged($event)"
                    (pageChanged)="onPageChanged($event)"
                    (filteredCount)="filteredCounts.items = $event">
    <!--
  -->
    <ng-template #headerTemplate>
      <div class="flex justify-between my-2">
        <h2 class="p-0 m-0">{{ "COMMON."+ (structure | uppercase) +".LABEL" | translate }}</h2>
        <app-button color="secondary" type="button" (click)="newItemList()">
          <div class="items-center flex gap-2"><mat-icon class="material-icons-outlined">add_circle</mat-icon><span>Nuevo</span></div>
        </app-button>
      </div>


    <ng-template #tableHeaderTemplate role="list" *ngIf="items.length > 0 && !showSpinnerItems" class="w-full max-h-[300px] overflow-y-auto">
      <div class="*:mb-2 *:py-2 *:font-[400] flex justify-between gap-x-6 w-full table-header">
        <div *ngIf="structure == 'promo' || structure == 'send_money'" class="w-1/4 text-start !font-bold !m-0 !p-0">{{ 'LISTS.'+ (structure | uppercase) +'.ID' | translate }}</div>
        <ng-container *ngIf="structure == 'promo'">
          <div class="w-1/6 text-start !font-bold !m-0 !p-0">{{ 'LISTS.'+ (structure | uppercase) +'.APPLYESTO' | translate }}</div>
          <div class="w-1/6 text-start !font-bold !m-0 !p-0">{{ 'LISTS.'+ (structure | uppercase) +'.DISCOUNT' | translate }}</div>
          <div class="w-1/6 text-start !font-bold !m-0 !p-0">{{ 'LISTS.'+ (structure | uppercase) +'.FROMDATE' | translate }}</div>
          <div class="w-1/6 text-start !font-bold !m-0 !p-0">{{ 'LISTS.'+ (structure | uppercase) +'.TODATE' | translate }}</div>
          <div class="w-1/6 text-start !font-bold !m-0 !p-0">{{ 'LISTS.'+ (structure | uppercase) +'.ACTIVE' | translate }}</div>
        </ng-container>

        <ng-container *ngIf="structure == 'send_money'">
          <div class="w-1/6 text-start !font-bold !m-0 !p-0">{{ 'LISTS.'+ (structure | uppercase) +'.ALLOWCARD' | translate }}</div>
          <div class="w-1/6 text-start !font-bold !m-0 !p-0">{{ 'LISTS.'+ (structure | uppercase) +'.ALLOWFREECARD' | translate }}</div>
          <div class="w-1/6 text-start !font-bold !m-0 !p-0">{{ 'LISTS.'+ (structure | uppercase) +'.MAXCARD' | translate }}</div>

          <div class="w-1/6 text-start !font-bold !m-0 !p-0">{{ 'LISTS.'+ (structure | uppercase) +'.ALLOWDB' | translate }}</div>
          <div class="w-1/6 text-start !font-bold !m-0 !p-0">{{ 'LISTS.'+ (structure | uppercase) +'.ALLOWFREEDB' | translate }}</div>
          <div class="w-1/6 text-start !font-bold !m-0 !p-0">{{ 'LISTS.'+ (structure | uppercase) +'.MAXDB' | translate }}</div>
        </ng-container>

        <ng-container *ngIf="structure == 'partner'">
          <div class="w-1/6 text-start !font-bold !m-0 !p-0">{{ 'LISTS.'+ (structure | uppercase) +'.PARTNER' | translate }}</div>
          <div class="w-1/6 text-start !font-bold !m-0 !p-0">{{ 'LISTS.'+ (structure | uppercase) +'.APPLIES_TO' | translate }}</div>
          <div class="w-1/6 text-start !font-bold !m-0 !p-0">{{ 'LISTS.'+ (structure | uppercase) +'.RANGES' | translate }}</div>
          <div class="w-1/6 text-start !font-bold !m-0 !p-0">{{ 'LISTS.'+ (structure | uppercase) +'.CREATED' | translate }}</div>
          <div class="w-1/6 text-start !font-bold !m-0 !p-0">{{ 'LISTS.'+ (structure | uppercase) +'.UPDATED' | translate }}</div>
        </ng-container>
        <div class="w-20 text-center !font-bold !m-0 !p-0">{{ 'BTB.DASHBOARD.TABLE.ACTIONS' | translate }}</div>
      </div>
    </ng-template>
    <ng-template #itemTemplate let-item role="list" *ngIf="items.length > 0 && !showSpinnerItems" class="w-full max-h-[300px] overflow-y-auto">
      <div class="*:mb-2 *:py-2 *:font-[400] items-center flex justify-between gap-x-6 w-full">
        <div *ngIf="structure == 'promo' || structure == 'send_money'" class="w-1/4 !font-bold">{{ item.id }}</div>
        <ng-container *ngIf="structure == 'promo'">
          <div class="w-1/6 text-start">{{ item.applyesTo }}</div>
          <div class="w-1/6 text-start">{{ item.discount }} {{item.unit == "" ? '€' : item.unit}}</div>
          <div class="w-1/6 text-start">{{ item.fromDate | date:'dd/MM/yyyy HH:mm' }}</div>
          <div class="w-1/6 text-start">{{ item.toDate | date:'dd/MM/yyyy HH:mm' }}</div>
          <div class="w-1/6 text-center"><mat-icon class="material-icons-outlined {{ item.active ? 'text-green-700' : 'text-red-700' }}">{{ item.active ? 'check_box' : 'check_box_outline_blank' }}</mat-icon></div>
        </ng-container>

        <ng-container *ngIf="structure == 'send_money'">
          <div class="w-1/6 text-center"><mat-icon class="material-icons-outlined {{ item.allowCard? 'text-green-700' : 'text-red-700' }}">{{ item.allowCard ? 'check_box' : 'check_box_outline_blank' }}</mat-icon></div>
          <div class="w-1/6 text-center"><mat-icon class="material-icons-outlined {{ item.allowFreeCard? 'text-green-700' : 'text-red-700' }}">{{ item.allowFreeCard ? 'check_box' : 'check_box_outline_blank' }}</mat-icon></div>
          <div class="w-1/6 text-start">{{ item.maxCard }}</div>

          <div class="w-1/6 text-center"><mat-icon class="material-icons-outlined {{ item.allowDB? 'text-green-700' : 'text-red-700' }}">{{ item.allowDB ? 'check_box' : 'check_box_outline_blank' }}</mat-icon></div>
          <div class="w-1/6 text-center"><mat-icon class="material-icons-outlined {{ item.allowFreeDB? 'text-green-700' : 'text-red-700' }}">{{ item.allowFreeDB ? 'check_box' : 'check_box_outline_blank' }}</mat-icon></div>
          <div class="w-1/6 text-start">{{ item.maxDB }}</div>
        </ng-container>

        <ng-container *ngIf="structure == 'partner'">
          <div class="w-1/6 text-start">{{ item.partnerCode }}</div>
          <div class="w-1/6 text-start">{{ getConditionTypeText(item) }}</div>
          <div class="w-1/6 text-start" style="white-space: pre-line;">{{ getRangesText(item) }}</div>
          <div class="w-1/6 text-start">{{ item.createdAt | date:'dd/MM/yyyy HH:mm' }}</div>
          <div class="w-1/6 text-start">{{ item.updatedAt | date:'dd/MM/yyyy HH:mm' }}</div>
        </ng-container>
        <div class="w-20 text-center">
          <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item type="button" (click)="editItemList(item);">
              <mat-icon>edit</mat-icon>
              <span>Editar</span>
            </button>
            <button mat-menu-item type="button" (click)="deleteItemList(item);">
              <mat-icon>delete</mat-icon>
              <span>Borrar</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </ng-template>

          </ng-template>


      <div *ngIf="filteredCounts.items == 0 && !showSpinnerItems" class="w-full content-center h-[200px]">
        <div class="!font-medium text-center">
          <div class="w-100 text-center text-gray-500"><mat-icon class="!text-[100px] !size-[100px]" style="color:#cfcfcf;">receipt_long</mat-icon></div>
          {{ "COMPONENTS.BLOCKS.NO_INVOICES" | translate }}
        </div>
      </div>

      <ng-template #footerTemplate>
        <footer>{{ "COMMON.TOTAL" | translate }}: {{ filteredCounts.items }} {{ "COMMON."+ (structure | uppercase) +".LABEL" | translate }}</footer>
      </ng-template>
  </app-generic-list>
</div>

<div class="edit_block" [hidden]="!editMode">
  <h2>Edición</h2>
  <app-conditions-form [form_structure]="structure" [item]="currentItem" (editMode)="toggleMostrarBloque($event)"></app-conditions-form>
</div>

<div class="loading-mask" *ngIf="showSpinnerItems">
  <mat-spinner diameter="50" strokeWidth="3"></mat-spinner>
</div>
